export default "__VITE_ASSET__CKl2nWuM__"